module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('table', {
    staticClass: "chapter-title-corner-decorations",
    attrs: {
      "width": "100%"
    }
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-left-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-left",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_left.png"
    }
  })])]), _c('td', {
    staticClass: "chapter-title-corner-decoration-middle-column"
  }), _c('td', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('div', {
    staticClass: "chapter-title-corner-decoration-right-column"
  }, [_c('img', {
    staticClass: "chapter-title-corner-decoration-right",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_corner_decoration_right.png"
    }
  })])])])])]), _c('div', {
    staticClass: "chapter-title"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-above-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-above",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_above.png"
    }
  })])]), _c('h1', {
    staticClass: "chapter-title"
  }, [_vm._v("Dante Black ")]), _vm._v(" "), _c('h1', [_vm._v("Age 18")]), _vm._v(" "), _c('h1', [_vm._v("San Diego, California U.S.A.")]), _vm._v(" "), _c('div', {
    staticClass: "chapter-title-decoration-below"
  }, [_c('div', {
    staticClass: "chapter-title-decoration-below-inner"
  }, [_c('img', {
    staticClass: "chapter-title-decoration-below",
    attrs: {
      "alt": "image",
      "src": "d2d_images/chapter_title_below.png"
    }
  })])])]), _c('p', {
    staticClass: "section-break"
  }, [_vm._v("––––––––")]), _c('div', {
    staticClass: "decoration-scene-break"
  }, [_c('div', {
    staticClass: "decoration-scene-break-inner"
  }, [_c('img', {
    staticClass: "decoration-scene-break",
    attrs: {
      "alt": "image",
      "src": "d2d_images/scene_break.png"
    }
  })])]), _vm._v(" "), _c('p', {
    staticClass: "first-in-scene",
    staticStyle: {
      "text-align": "justify"
    }
  }, [_c('span', {
    staticClass: "first-scene-phrase"
  }, [_c('span', {
    staticClass: "first-in-scene character-i"
  }, [_vm._v("I")]), _vm._v(" PULLED UP IN FRONT")]), _vm._v(" of the Jones’ house in San Diego and killed the engine.  Staring at the steering wheel, I tried to steel myself for what was to come.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It had been months since the explosion at Black Biotech.  There were nights when I still had nightmares about that day.  Nights when I could see myself heading up the elevator of the high-rise with Summer.  Hand in hand we had walked to an office window and looked out at the spectacular lights of Los Angeles.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("In my dreams, her long, caramel colored hair always blew in the breeze and her beautiful big hazel eyes were always filled with wonder.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Then, out of nowhere, my father would appear, the Condor sent to make sure I follow through with my mission or he would complete my mission for me.  In every dream, I argued with him, wanting to change my mission, wanting to savor my last moments with Summer, but he always came back, with a shotgun aimed at me or Summer or with a switch in his hands... the very one that would ignite the explosives that would topple Black Biotech’s building.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Some nights I managed to wake up before the dream became the nightmare that it truly was, but most nights I simply relived the reality of that day.  The horrible reality of that deadly explosion.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I looked up at the house, the house where Summer now lived with her mother, Meecham.  As usual, a wave of intense guilt swept over me as I thought of Summer’s injuries following the explosion.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Not only had I not been able to save her, but I myself had been thrown outside seconds before the explosion went off.  I couldn’t save her.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Good, but that had only added to the guilt for what had happened to Summer.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Swallowing my anger and frustration, I got out of the car and headed to the door.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes,” a voluptuous young blonde woman said as she opened the door.  Her eyes lit up as she looked me over, but she remained calm and cool.  “Can I help you with anything?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes,” I said, not willing to play along with her flirtatious greeting.  “I’m Dante.  Dante Black.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“All right,” she said with a hungry smile as she looked me over.  “You’re quite handsome. What is a good-looking guy like you doing?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m here to see Summer,” I added.  “Is her mother, Ms. Meecham Jones, here?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A tall woman with Summer’s hazel eyes and caramel hair finally came to the door.  “Who is it, Brenda?  Oh...” she added as she saw me.  “Dante.”  She turned dismissively to Brenda.  “It’s all right.  I’ll take it from here.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She opened the door wider to let me in.  “Dante. Dante Black. This is a surprise. I never thought I’d ever get to meet you in person. I’m Meecham Jones, Summer’s mother. My little sister Sookie did tell me all about you and Summer the year Summer stayed with Sookie in her Malibu pad. I do apologize about Brenda,” Meecham said as she led me to Summer’s room.  “She’s a nurse our family friend hired to help me with Summer.  It’s been  months since the accident...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I see.” I said softly.  “Is Summer doing better?” I couldn’t help the desperation in my voice. She was completely bandaged and barely alive when I sneaked by her house and saw her from afar.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“She’s doing better,” Meecham said.  “Sookie did her best handling things until I got home from my mission. I’m glad we were able to keep Summer safe and incognito at home while she is healing, but I’m afraid it’s taking a while longer than we hoped. And her memory of the year she spent with Sookie never returned.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My heart fell. Summer still didn’t remember us. She still had no idea who I was.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Meecham gently pushed open a door and gestured that I stay put while she went to Summer’s bedside.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Summer?” she said gently.  “Are you awake, Summer?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Groggy, Summer opened her eyes and looked at her mother.  She offered her an almost imperceptible nod.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She still had a cast on her arm and a large bandage across her chest.  There was also a small bandage at her throat from the tracheotomy she’d needed.  While they were neatly covered with the white and yellow quilt, I knew that her legs had suffered much damage as well.  The doctors had said that it would be a while before she would walk again.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“How are you feeling this morning?” Meecham said.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Not bad,” Summer said as she shifted to sit up a bit more.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“There’s someone here who would like to see you,” Meecham said.  “Are you up for it?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sure,” Summer said with a grim expression on her face.  “Why not?  I have nothing else to do.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I took a few steps to enter the room but kept my distance.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Who is he?” Summer said.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The question never failed to destroy me.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“A new doctor?” she went on.  “A nurse?  He seems kind of young.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, honey,” Meecham said.  She looked lovingly at Summer.  “You know, we were wondering what you might remember about the day of this accident you had.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’ve told you already, Mom,” Summer said, her brow creasing into an unhappy frown.  She picked up the colorful cushion at her side and hugged it.  “You know I don’t remember anything.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Meecham glanced at me.  “The doctors say the concussion can make her a little testy from time to time.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I nodded my understanding.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Honey,” Meecham said turning back to her daughter.  “There is a possibility that you’ll remember what happened to you at some point.  I know it’s a bit annoying, but I have to ask you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Summer looked down at the cushion she was hugging and played with the fringe around the edge.  “I know,” she said more gently.  “I’m sorry.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She glanced at me then back at her mom.  “I don’t remember what happened.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Do you want to try to backtrack to see what happened just before it?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Summer shook her head.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I was gone for a year before your accident,” Meecham nonetheless said.  “Do you remember anything about what you did while I was gone?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Where did you go?” Summer said with a childlike tilt of her head.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Well,” Meecham said with a soft chuckle.  “I can’t tell you exactly where I went, but it was a very important mission... something that I had to take care of personally.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Mission?” Summer said.  “Mom, I don’t remember which mission. I know you have several. But for what?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Meecham smiled.  “Remember what I told you yesterday?  That I’m in the military.  I’m a strategist.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Summer nodded heavily.  “Oh, yeah.  Right.  You’re a high ranking officer or something.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Right.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And you left me here alone?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“No, sweetie,” Meecham said.  “You weren’t alone.  You went to live with my sister, Sookie, remember... in Malibu.  You even sent me messages telling me how much you loved being there... the beach house, the ocean.... You love living with your Aunt Sookie.  She is a wild one and I think you liked that.  I think you liked the fact that she let you do things that you knew I never would.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sounds like fun,” Summer said in a disheartening flat tone.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Sookie even calls her house ‘the Pad’ as if she were still in the 70s.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Summer shook her head.  “I don’t remember, Mom.  I mean, I know who Sookie is, and I do love her.  But I don’t remember living with her.  I don’t remember being in Malibu.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“What about the private school Aunt Sookie enrolled you in?” Meecham said.  “Do you remember anything about Hidden Falls High?  Any of the teachers?  Any of the students?  Any of your friends?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Again, Summer shook her head.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I couldn’t take it any longer.  I knew that Meecham disapproved of my pushing the issue, but I nonetheless stepped forward.  “What about me?” I said, my heart pounding as I looked into Summer’s big hazel eyes.  “Do you remember me?  Dante Black.  Remember?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She looked up at me and furrowed her brow.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Look carefully at me, Summer,” I said.  “Look at me.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Smiling, she looked deep into my eyes, and for a moment I felt an optimistic stirring in my gut.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She recognizes me, I thought.  Her mind has finally cleared, and she knows who I am.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You do have beautiful and, dare I say, unforgettable green eyes,” she said.  “The contrast between your eyes and your jet black hair is startling.  Very attractive.  I’m sure you’re very popular with girls.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I waited for the inevitable ‘but’.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“You seem like a great guy,” she went on.  “But, I don’t know you.  I don’t remember knowing you.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Even a few months after the accident...  I thought as I swallowed the tears that threatened to stream down my face.  I closed my eyes to hide my frustration and pain.  But, damn it, every time I came, every time I hoped and every time that she told me she had no idea who I was... it was like losing her all over again.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“We were at Black Biotech,” I said softly, once again hoping the name would spark something.  “We’d gone up to my office.  My father showed up...”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("She just looked at me, completely blank.  “What happened to your father?” she said after a moment.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Pressing my lips together, I turned away and closed my eyes, hoping to blink the tears away.  “He died in that explosion,” I said as I turned to face her once more.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“I’m sorry to hear that,” Summer said.  Then she cocked her head to the side, her eyes suddenly inquisitive.  “You said your name was Dante Black?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes,” I said, letting my hopes, once again, rise.  “Yes.  Dante Black.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“And you said the explosion happened at Black Biotech?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes,” I said, coming to the side of her bed.  I desperately wanted to reach out to take a hold of her hand... to touch her in any way.  “Exactly.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Black,” she said simply.  “Is there a connection... you and this company?”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Another stab in the heart.  Another hope dashed.  Another moment of thinking I could have her again, only to realize she was lost.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("It was torture.  It was constant torture, and I knew that I would have to move on with my life at some point.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-style": "italic",
      "text-align": "justify"
    }
  }, [_vm._v("Just not now.  Now, I still need to cling to every ounce of hope.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("“Yes,” I said quietly.  “My father founded Black Biotech.”")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("I looked at her, thinking of everything that had brought us together.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("A hit.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("The Inner Circle.  ")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("My father.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He was the one who had initiated me into the Circle so many years earlier.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He was the one who had trained me and who had shown me that a cold, hard heart was a safe one.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But when I received the assignment – the hit on Summer – it was my father who understood the love that I had for her.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("He was the one who had come through in the end and had given his life so that I could go on with mine.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("Hmph...")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "text-align": "justify"
    }
  }, [_vm._v("But what a shitty life it now was without Summer.")]), _vm._v(" "), _c('p', {
    staticStyle: {
      "font-size": "large",
      "page-break-before": "always",
      "text-align": "center",
      "text-indent": "0"
    }
  }, [_vm._v("Chapter 1")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-269ca73a","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/c004.vue
// module id = 69
// module chunks = 0